import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

import { useSelectAllList } from "@/hooks/api/list/useSelectAllList";
import { useSelectAllSearch } from "@/hooks/api/search/useSelectAllSearch";
import Checkbox from "@/components/atoms/Checkbox";
import CompanyLogo from "@/components/molecules/company/CompanyLogo";
import BaseColumn from "@/components/molecules/table/BaseColumn";
import { searchColumns, SearchColumnsProps } from "@/components/organisms/search/searchColumns";

const companyNameColumn = ({ t, listId, searchParams }: SearchColumnsProps): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => row.info?.name,
    id: searchColumns(t).company_name.id,
    enableHiding: false,
    header: ({ table }) => {
      const { data: listIds } = useSelectAllList({ id: listId });
      const { data: searchIds } = useSelectAllSearch(searchParams);

      return (
        <>
          <Checkbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={() => {
              if (table.getIsAllRowsSelected()) {
                table.setRowSelection({});
              } else {
                const allIds = searchParams ? searchIds : listIds;
                table.setRowSelection(Object.fromEntries(allIds!.ids.map((id) => [id, true])));
              }
            }}
          />
          <HiOutlineOfficeBuilding className={"size-4 stroke-2 text-quaternary"} />
          {searchColumns(t).company_name.name}
        </>
      );
    },
    cell: (info) => (
      <div className={"flex items-center space-x-2"}>
        <CompanyLogo url={info.row.original.info.logo} />
        <span>{info.getValue<string>()}</span>
      </div>
    ),
    meta: {
      disableReorder: true,
    },
  });

export default companyNameColumn;
